import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["logContainer", "emptyState"]

  connect() {
    // Watch for new log entries via MutationObserver
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          this.onLogEntryAdded()
        }
      })
    })

    this.observer.observe(this.logContainerTarget, { childList: true })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  clear() {
    // Remove all log entries, show empty state
    const logEntries = this.logContainerTarget.querySelectorAll('[data-log-entry]')
    logEntries.forEach(entry => entry.remove())
    this.emptyStateTarget.classList.remove('hidden')
  }

  // Called when a new log entry is added (via MutationObserver)
  onLogEntryAdded() {
    // Hide empty state when first entry is added
    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.add('hidden')
    }

    // Auto-scroll to bottom
    this.logContainerTarget.scrollTop = this.logContainerTarget.scrollHeight
  }
}
